module.exports = __webpack_public_path__ + "img/jiangchangqing.e7d0326a.png";